import React, { useState, useEffect } from 'react'
import landinglogo from "./../../images/landinglogo.png";

const Header = () => {
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
    const [isScrolled, setIsScrolled] = useState(false);

    const openInNewTab = (url) => {
        const newWindow = window.open(url, '_blank', 'noopener,noreferrer')
        if (newWindow) newWindow.opener = null
        setIsMobileMenuOpen(false);
    }

    const toggleMobileMenu = () => {
        setIsMobileMenuOpen(!isMobileMenuOpen);
        if (!isMobileMenuOpen) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'unset';
        }
    }

    const closeMobileMenu = () => {
        setIsMobileMenuOpen(false);
        document.body.style.overflow = 'unset';
    }

    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 50) {
                setIsScrolled(true);
            } else {
                setIsScrolled(false);
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
            document.body.style.overflow = 'unset';
        };
    }, []);

    const handleSmoothScroll = (e, targetId) => {
        e.preventDefault();
        closeMobileMenu();

        const targetElement = document.querySelector(targetId);
        if (targetElement) {
            targetElement.scrollIntoView({
                behavior: 'smooth',
                block: 'start'
            });
        }
    };

    return (
        <header
            id="header"
            className={`fixed-top ${isScrolled ? 'header-scrolled' : ''}`}
            style={{
                transition: 'all 0.3s ease',
                backgroundColor: isScrolled ? '#ffffff' : 'transparent',
                boxShadow: isScrolled ? '0 2px 15px rgba(0, 0, 0, 0.1)' : 'none',
                padding: isScrolled ? '10px 0' : '15px 0',
            }}
        >
            <div className="container d-flex align-items-center justify-content-between">
                {/* Logo */}
                <a
                    href="#hero"
                    className="logo"
                    onClick={(e) => handleSmoothScroll(e, '#hero')}
                    style={{ textDecoration: 'none' }}
                >
                    <img
                        src={landinglogo}
                        alt="Easy Software"
                        style={{
                            maxHeight: '50px',
                            transition: 'all 0.3s ease'
                        }}
                    />
                </a>

                {/* Navigation */}
                <nav
                    id="navvbarr"
                    className={`navvbarr ${isMobileMenuOpen ? 'mobile-nav-active' : ''}`}
                >
                    <ul className="nav-menu">
                        <li>
                            <a
                                className="nav-link scrollto active"
                                href="#hero"
                                onClick={(e) => handleSmoothScroll(e, '#hero')}
                            >
                                Home
                            </a>
                        </li>
                        <li>
                            <a
                                className="nav-link scrollto"
                                href="#about"
                                onClick={(e) => handleSmoothScroll(e, '#about')}
                            >
                                About
                            </a>
                        </li>
                        <li className="dropdown">
                            <a href="#" onClick={(e) => e.preventDefault()}>
                                <span>Features</span>
                                <i className="bi bi-chevron-down" style={{ marginLeft: '5px' }}></i>
                            </a>
                            <ul className="dropdown-menu">
                                <li>
                                    <a
                                        className="scrollto"
                                        href="#student"
                                        onClick={(e) => handleSmoothScroll(e, '#student')}
                                    >
                                        Student
                                    </a>
                                </li>
                                <li>
                                    <a
                                        className="scrollto"
                                        href="#teacher"
                                        onClick={(e) => handleSmoothScroll(e, '#teacher')}
                                    >
                                        Teacher
                                    </a>
                                </li>
                                <li>
                                    <a
                                        className="scrollto"
                                        href="#admin"
                                        onClick={(e) => handleSmoothScroll(e, '#admin')}
                                    >
                                        Admin
                                    </a>
                                </li>
                            </ul>
                        </li>
                        <li>
                            <a
                                className="nav-link scrollto"
                                href="##"
                                // onClick={(e) => {
                                //     e.preventDefault();
                                //     openInNewTab("https://jobs.eliteinfotechnp.com/");
                                // }}
                                onClick={(e) => handleSmoothScroll(e, '#jobListPage')}
                            >
                                Jobs
                            </a>
                        </li>
                        <li>
                            <a
                                className="nav-link scrollto"
                                href="#contact"
                                onClick={(e) => handleSmoothScroll(e, '#contact')}
                            >
                                Contact Us
                            </a>
                        </li>
                        <li className="login-btn">
                            <button
                                className="getstarted"
                                onClick={() => openInNewTab("/login")}
                            >
                                Log In
                            </button>
                        </li>
                    </ul>
                </nav>

                {/* Mobile Navigation Toggle Icon */}
                <button
                    className={`mobile-nav-toggle ${isMobileMenuOpen ? 'active' : ''}`}
                    onClick={toggleMobileMenu}
                    aria-label="Toggle navigation"
                >
                    <span className="bar"></span>
                    <span className="bar"></span>
                    <span className="bar"></span>
                </button>

                {/* Overlay for mobile menu */}
                {isMobileMenuOpen && (
                    <div
                        className="mobile-menu-overlay"
                        onClick={closeMobileMenu}
                    ></div>
                )}
            </div>

            <style jsx>{`
                /* Desktop Styles */
                .nav-menu {
                    display: flex;
                    align-items: center;
                    list-style: none;
                    margin: 0;
                    padding: 0;
                }
                
                .nav-menu li {
                    position: relative;
                    margin: 0 5px;
                }
                
                .nav-menu li a {
                    display: flex;
                    align-items: center;
                    padding: 10px 15px;
                    color: #000;
                    font-size: 15px;
                    font-weight: 500;
                    text-decoration: none;
                    transition: 0.3s;
                    white-space: nowrap;
                }
                
                .nav-menu li a:hover,
                .nav-menu li a.active {
                    color: #47b2e4;
                }
                
                .dropdown {
                    position: relative;
                }
                
                .dropdown-menu {
                    position: absolute;
                    top: 100%;
                    left: 0;
                    z-index: 99;
                    visibility: hidden;
                    opacity: 0;
                    min-width: 200px;
                    background: #fff;
                    box-shadow: 0px 0px 30px rgba(127, 137, 161, 0.25);
                    transition: 0.3s;
                    border-radius: 4px;
                    padding: 10px 0;
                    list-style: none;
                }
                
                .dropdown:hover .dropdown-menu {
                    visibility: visible;
                    opacity: 1;
                }
                
                .dropdown-menu li a {
                    padding: 10px 20px;
                    color: #000 !important;
                    font-size: 14px;
                }
                
                .dropdown-menu li a:hover {
                    color: #47b2e4 !important;
                    background: #f8f9fa;
                }
                
                .getstarted {
                    background: transparent;
                    border: 2px solid #47b2e4 !important;
                    padding: 8px 25px !important;
                    border-radius: 50px;
                    font-size: 14px;
                    font-weight: 600;
                    color: #000;
                    transition: 0.3s;
                    cursor: pointer;
                    margin-left: 15px;
                }
                
                .getstarted:hover {
                    background: #47b2e4;
                    color: #fff !important;
                }

                /* Mobile Navigation Toggle - Hidden on Desktop */
                .mobile-nav-toggle {
                    display: none;
                    background: transparent;
                    border: none;
                    cursor: pointer;
                    padding: 10px;
                    z-index: 9999;
                }

                /* Mobile Styles */
                @media (max-width: 768px) {
                    .mobile-nav-toggle {
                        display: flex !important;
                        flex-direction: column;
                        justify-content: center;
                        align-items: center;
                        width: 40px;
                        height: 40px;
                        position: relative;
                    }
                    
                    .mobile-nav-toggle .bar {
                        display: block;
                        width: 25px;
                        height: 3px;
                        margin: 3px 0;
                        background-color: #000;
                        transition: all 0.3s ease-in-out;
                    }
                    
                    .mobile-nav-toggle.active .bar:nth-child(1) {
                        transform: translateY(6px) rotate(45deg);
                    }
                    
                    .mobile-nav-toggle.active .bar:nth-child(2) {
                        opacity: 0;
                    }
                    
                    .mobile-nav-toggle.active .bar:nth-child(3) {
                        transform: translateY(-6px) rotate(-45deg);
                    }
                    
                    .mobile-menu-overlay {
                        position: fixed;
                        top: 0;
                        left: 0;
                        width: 100%;
                        height: 100%;
                        background-color: rgba(0, 0, 0, 0.5);
                        z-index: 9997;
                    }
                    
                    .navvbarr {
                        position: fixed;
                        top: 0;
                        right: -280px;
                        width: 280px;
                        height: 100vh;
                        background: #fff;
                        transition: right 0.3s ease-in-out;
                        z-index: 9998;
                        padding: 80px 20px 20px;
                        box-shadow: -5px 0 15px rgba(0, 0, 0, 0.1);
                        overflow-y: auto;
                    }
                    
                    .navvbarr.mobile-nav-active {
                        right: 0 !important;
                    }
                    
                    .navvbarr .nav-menu {
                        flex-direction: column;
                        align-items: flex-start;
                        width: 100%;
                        display: block;
                    }
                    
                    .navvbarr .nav-menu li {
                        width: 100%;
                        margin: 5px 0;
                        display: block;
                    }
                    
                    .navvbarr .nav-menu li a {
                        color: #000;
                        font-size: 16px;
                        padding: 12px 0;
                        display: block;
                        border-bottom: 1px solid #eee;
                    }
                    
                    .navvbarr .nav-menu li:last-child a {
                        border-bottom: none;
                    }
                    
                    .navvbarr .dropdown {
                        width: 100%;
                        position: relative;
                    }
                    
                    .navvbarr .dropdown-menu {
                        position: static;
                        visibility: visible !important;
                        opacity: 1 !important;
                        display: none;
                        padding-left: 20px;
                        margin: 5px 0;
                        background: #f9f9f9;
                        border-radius: 5px;
                        box-shadow: none;
                        width: 100%;
                    }
                    
                    .navvbarr .dropdown:hover .dropdown-menu,
                    .navvbarr .dropdown .dropdown-menu {
                        display: none;
                    }
                    
                    .navvbarr .dropdown.active .dropdown-menu {
                        display: block;
                    }
                    
                    .navvbarr .dropdown-menu li a {
                        font-size: 14px;
                        color: #333;
                        border-bottom: 1px solid #e5e5e5;
                        padding: 10px 15px;
                    }
                    
                    .navvbarr .dropdown-menu li:last-child a {
                        border-bottom: none;
                    }
                    
                    .navvbarr .login-btn {
                        margin-top: 20px;
                        width: 100%;
                    }
                    
                    .navvbarr .getstarted {
                        width: 100%;
                        padding: 12px !important;
                        background: #47b2e4 !important;
                        color: #fff !important;
                        border: none !important;
                        font-size: 16px;
                        border-radius: 5px;
                        cursor: pointer;
                        margin-left: 0;
                    }
                    
                    #header.header-scrolled {
                        background: #fff !important;
                    }
                }

                /* Desktop styles override */
                @media (min-width: 769px) {
                    .mobile-nav-toggle {
                        display: none !important;
                    }
                    
                    .mobile-menu-overlay {
                        display: none !important;
                    }
                }

                .bi-chevron-down {
                    color: #000 !important;
                }
            `}</style>
        </header>
    )
}

export default Header